import React from 'react'
import styled from 'styled-components'
import { Container, Col, Row } from 'react-bootstrap'
import SharedTitle from '~/components/UI/SharedTitle'
import Text from '~/components/UI/Text'
import { useTranslation } from '~/i18n'
import Box from '~/components/UI/Box'
import Icon from '~/components/UI/Icon'
import { COLORS } from '~/components/UI/Constants'
import appendCDN from '~/utils/append_cdn_link'
import breakpoints from '../UI/breakpoints'
import Button from '../Button'

const MyContainer = styled.div`
  padding: 0;
  padding-bottom: 40px;
`
const Img = styled.div`
  height: 240px;
  text-align: center;
  margin-bottom: 40px;
  img {
    height: 100%;
  }
  ${breakpoints.lg} {
    height: 290px;
  }
`

const List = styled.ul`
  margin-top: 32px;
  list-style: none;
  padding: 0;
  li {
    margin-bottom: 16px;
    display: flex;
    >span {
      font-size: 24px;
      line-height: 1.6;
      ::before {
        color: ${COLORS.PRIMARY}
      }
    }
    > div {
      margin-left: 16px;
      p:first-child {
        margin-bottom: 8px;
      }
    }
  }
`

const Section5Profit = () => {
  const [t] = useTranslation()
  return (
    <MyContainer>
      <Container>
        <SharedTitle centered padding='0 0 40px 0'>
          {t`Nguồn lợi nhuận`}
        </SharedTitle>
        <Row>
          <Col md={6}>
            <Img>
              <img src={appendCDN('/img/profit1.png')} />
            </Img>
            <Box>
              <Text centered bold size={32}>
                {t`Thu nhập thụ động`}
              </Text>
              <List>
                <li>
                  <Icon name='direction-right' />
                  <Box>
                    <Text size={24} bold>
                      {t`Lợi nhuận cam kết từ Infina`}
                    </Text>
                    <Text>
                      {t`Tuỳ theo bất động sản, Infina cam kết lợi nhuận tối thiểu hằng năm từ 6% - 9%.`}
                    </Text>
                  </Box>
                </li>
                <li>
                  <Icon name='direction-right' />
                  <Box>
                    <Text size={24} bold>
                      {t`Lợi nhuận từ việc cho thuê`}
                    </Text>
                    <Text>
                      {t`Những bất động sản đã hoàn thiện sẽ được cho thuê và lợi nhuận sẽ chia đều cho khách đầu tư.`}
                    </Text>
                  </Box>
                </li>
              </List>
            </Box>
          </Col>
          <Col md={6}>
            <Img>
              <img src={appendCDN('/img/profit2.png')} />
            </Img>
            <Box>
              <Text centered bold size={32}>
                {t`Lợi nhuận chủ động`}
              </Text>
              <List>
                <li>
                  <Icon name='direction-right' />
                  <Box>
                    <Text size={24} bold>
                      {t`Bán phần sở hữu của bạn`}
                    </Text>
                    <Text>
                      {t`Bạn có thể bán ra phần sở hữu của mình trên sàn giao dịch và thu phần lợi nhuận chênh lệch mong muốn`}
                    </Text>
                  </Box>
                </li>
                <li>
                  <Icon name='direction-right' />
                  <Box>
                    <Text size={24} bold>
                      {t`Bán nguyên căn`}
                    </Text>
                    <Text>
                      {t`Infina sẽ đánh giá, phân tích thời điểm tốt nhất và bán ra bất động sản để chốt lời cho khách đầu tư`}
                    </Text>
                  </Box>
                </li>
              </List>
            </Box>
          </Col>
        </Row>
      </Container>
      <Box padding='40px 0'>
        <Button primary margin='auto' link href='/properties' border='0'>
          <Text bold color='#fff'>
            {t`Đầu Tư Ngay!`}
          </Text>
        </Button>
      </Box>
    </MyContainer>
  )
}

export default Section5Profit
